var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel panel-bordered mb-0" }, [
    _c("div", { staticClass: "panel-heading" }, [
      _c("div", { staticClass: "panel-title" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.questionId
                ? "Edit Question #" + _vm.questionId
                : "Create Question"
            ) +
            " "
        ),
      ]),
      _c("div", { staticClass: "panel-actions panel-actions-keep" }, [
        _c("span", { staticClass: "save-state", class: _vm.saveStateClass }, [
          _vm._v(_vm._s(_vm.saveStateText)),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "panel-body" }, [
      _c("div", { staticClass: "form-group row" }, [
        _c("label", { staticClass: "form-control-label col-md-3" }, [
          _vm._v("Question Body"),
        ]),
        _c("div", { staticClass: "col-md-9" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.localQuestion.question_text,
                expression: "localQuestion.question_text",
                modifiers: { trim: true },
              },
            ],
            staticClass: "form-control",
            attrs: { rows: "3" },
            domProps: { value: _vm.localQuestion.question_text },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.localQuestion,
                    "question_text",
                    $event.target.value.trim()
                  )
                },
                _vm.onFieldInput,
              ],
              blur: [
                _vm.onFieldBlur,
                function ($event) {
                  return _vm.$forceUpdate()
                },
              ],
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "form-group row" }, [
        _c("label", { staticClass: "form-control-label col-md-3" }, [
          _vm._v("Choice 1"),
        ]),
        _c("div", { staticClass: "col-md-9" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.localQuestion.choice1,
                expression: "localQuestion.choice1",
                modifiers: { trim: true },
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.localQuestion.choice1 },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.localQuestion,
                    "choice1",
                    $event.target.value.trim()
                  )
                },
                _vm.onFieldInput,
              ],
              blur: [
                _vm.onFieldBlur,
                function ($event) {
                  return _vm.$forceUpdate()
                },
              ],
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "form-group row" }, [
        _c("label", { staticClass: "form-control-label col-md-3" }, [
          _vm._v("Choice 2"),
        ]),
        _c("div", { staticClass: "col-md-9" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.localQuestion.choice2,
                expression: "localQuestion.choice2",
                modifiers: { trim: true },
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.localQuestion.choice2 },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.localQuestion,
                    "choice2",
                    $event.target.value.trim()
                  )
                },
                _vm.onFieldInput,
              ],
              blur: [
                _vm.onFieldBlur,
                function ($event) {
                  return _vm.$forceUpdate()
                },
              ],
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "form-group row" }, [
        _c("label", { staticClass: "form-control-label col-md-3" }, [
          _vm._v("Correct Answer"),
        ]),
        _c("div", { staticClass: "col-md-9" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.localQuestion.correct_answer,
                  expression: "localQuestion.correct_answer",
                },
              ],
              staticClass: "form-control",
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.localQuestion,
                      "correct_answer",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                  _vm.onFieldBlur,
                ],
              },
            },
            [
              _c(
                "option",
                { attrs: { disabled: "" }, domProps: { value: null } },
                [_vm._v("Select answer")]
              ),
              _c("option", { domProps: { value: 1 } }, [_vm._v("1")]),
              _c("option", { domProps: { value: 2 } }, [_vm._v("2")]),
            ]
          ),
        ]),
      ]),
      _c("div", { staticClass: "form-group row mb-0" }, [
        _c("label", { staticClass: "form-control-label col-md-3" }, [
          _vm._v("Extra time"),
        ]),
        _c("div", { staticClass: "col-md-9" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.localQuestion.bonus_time,
                expression: "localQuestion.bonus_time",
                modifiers: { number: true },
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number", min: "0", max: "1000" },
            domProps: { value: _vm.localQuestion.bonus_time },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.localQuestion,
                    "bonus_time",
                    _vm._n($event.target.value)
                  )
                },
                _vm.onFieldInput,
              ],
              blur: [
                _vm.onFieldBlur,
                function ($event) {
                  return _vm.$forceUpdate()
                },
              ],
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "status-text mt-20" }, [
        _vm.validationMessage
          ? _c("span", { staticClass: "text-danger" }, [
              _vm._v(_vm._s(_vm.validationMessage)),
            ])
          : _vm.saveError
          ? _c("span", { staticClass: "text-danger" }, [
              _vm._v(_vm._s(_vm.saveError)),
            ])
          : _c("span", { staticClass: "text-muted" }, [
              _vm._v(" Changes are auto-saved when you leave each field. "),
            ]),
      ]),
    ]),
    _c("div", { staticClass: "panel-footer" }, [
      _c("div", { staticClass: "d-flex justify-content-end" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-round btn-default",
            attrs: { type: "button" },
            on: { click: _vm.close },
          },
          [
            _c("i", {
              staticClass: "icon md-close",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" Close "),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }